// src/components/UploadSalesCSV.js
import React, { useState } from 'react';
import Papa from 'papaparse';
import { db } from '../firebase';
import {
  doc,
  updateDoc,
  increment,
  collection,
  getDocs,
} from 'firebase/firestore';

const norm = (s = '') =>
  s.toString().trim().toLowerCase().replace(/\s+/g, ' ');

export default function UploadSalesCSV() {
  const [status, setStatus] = useState('');
  const [removed, setRemoved] = useState([]); // ✅ list of {name, qty}

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setStatus('Processing…');
    setRemoved([]);

    try {
      const snap = await getDocs(collection(db, 'stock_shop_drinks'));
      const nameToId = {};
      const idToId   = {};
      snap.forEach((d) => {
        const data = d.data() || {};
        if (data.name) nameToId[norm(data.name)] = d.id;
        idToId[norm(d.id.replace(/_/g, ' '))] = d.id;
      });

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        transformHeader: (h) => (h || '').replace(/^\uFEFF/, '').trim(),
        complete: async ({ data }) => {
          const headers = Object.keys(data?.[0] || {});
          const itemKey =
            ['Product', 'Item'].find((k) => headers.includes(k)) || 'Product';
          const qtyKey =
            ['S.Qty', 'Qty'].find((k) => headers.includes(k)) || 'S.Qty';

          let updated = 0;
          const removedList = [];

          for (const row of data) {
            const rawName = (row[itemKey] ?? '').toString().trim();
            if (!rawName) continue;

            const sold = parseFloat(String(row[qtyKey] ?? '0').replace(',', '.'));
            if (!sold || isNaN(sold)) continue;

            const docId = nameToId[norm(rawName)] || idToId[norm(rawName)];
            if (!docId) continue;

            await updateDoc(doc(db, 'stock_shop_drinks', docId), {
              units: increment(-sold),
            });
            updated++;
            removedList.push({ name: rawName, qty: sold });
          }

          setRemoved(removedList);
          setStatus(`✅ Updated ${updated} drink items from CSV.`);
        },
        error: (err) => {
          console.error(err);
          setStatus('❌ Failed to parse CSV.');
        },
      });
    } catch (err) {
      console.error(err);
      setStatus('❌ Error reading drinks from Firestore.');
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📤 Upload Weekly POS CSV (Drinks)</h2>
      <input type="file" accept=".csv" onChange={handleFile} />
      <p>{status}</p>

      {/* ✅ Show bullet list of removed items */}
      {removed.length > 0 && (
        <ul style={{ marginTop: 10 }}>
          {removed.map((r, i) => (
            <li key={i}>
              {r.name} — {r.qty} unit{r.qty !== 1 ? 's' : ''} removed
            </li>
          ))}
        </ul>
      )}

      <p style={{ fontSize: '0.9em', color: '#666' }}>
        CSV must contain at least <code>Product</code> and <code>S.Qty</code> columns.
      </p>
    </div>
  );
}
